import { render, staticRenderFns } from "./accept.vue?vue&type=template&id=3aa3534b&scoped=true"
import script from "./accept.vue?vue&type=script&lang=js"
export * from "./accept.vue?vue&type=script&lang=js"
import style0 from "./accept.vue?vue&type=style&index=0&id=3aa3534b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3534b",
  null
  
)

export default component.exports